import { Component, PropTypes } from 'react'
import throttle from 'lodash.throttle'

import { colors } from '../constants/theme'

export default class DeviceProvider extends Component {
  static childContextTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    retina: PropTypes.bool
  };

  constructor(props, context) {
    super(props, context)
    this.state = {
      width: 0,
      retina: false
    }
    this.hasEffect = []
    this.distance = 0
  }

  updateDevice = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      retina: window.devicePixelRatio > 1.5
    })
  };

  draw = () => {
    window.requestAnimationFrame(this.draw)
    this.animate()
  };

  animate = () => {
    const scrollTop = window.scrollY !== undefined ? window.scrollY : window.pageYOffset

    const offset = scrollTop > this.scrollElement.scrollHeight - window.innerHeight
      ? 0
      : this.lastScrollTop - scrollTop
    const newDirection = offset < 0 ? 'down' : offset > 0 ? 'up' : this.direction

    if (newDirection === this.direction && Date.now() >= window.IS_SCROLLING) {
      this.distance += Math.abs(offset)
    } else {
      this.distance = 0
    }

    if (Date.now() > window.LAST_SCROLL + 1000) {
      this.distance = 0
    }

    this.direction = newDirection

    this.lastScrollTop = scrollTop
    const scrollPercentage = scrollTop / (window.innerHeight - this.nav.offsetHeight)

    this.nav.style.backgroundColor = `rgba(22, 24, 28, ${Math.max(
      0,
      Math.min(1.0, scrollPercentage)
    )})`

    if (this.direction === 'up' && this.distance > 300) {
      this.nav.style.transition = '200ms transform linear', this.nav.style.transform = 'translate3d(0, 0, 0)'
    }

    if (
      (this.direction === 'down' && this.distance > 70 || Date.now() > window.LAST_SCROLL + 3500) &&
      scrollTop > window.innerHeight
    ) {
      this.nav.style.transition = '200ms transform linear', this.nav.style.transform = `translate3d(0, -${this.nav.offsetHeight}px, 0)`
    }
    // // parallax
    // const allParallaxElements = document.querySelectorAll('[data-parallax-speed]')
    //
    // for (let i = 0; i < allParallaxElements.length; ++i) {
    //   const element = allParallaxElements[i]
    //
    //   const speed = parseFloat(element.attributes['data-parallax-speed'].value)
    //   const direction = element.hasAttribute('data-parallax-direction') ? element.attributes['data-parallax-direction'].value : 'vertical'
    //   const elementStart = element.offsetTop
    //   const parallaxOffestPercentage = element.hasAttribute('data-parallax-offset') ? parseFloat(element.attributes['data-parallax-offset'].value) : 0.0
    //   const parallaxStart = elementStart + parallaxOffestPercentage * window.innerHeight
    //
    //   if (scrollTop >= parallaxStart) {
    //     // do parallax magic
    //     const offset = speed * (scrollTop - parallaxStart) * -1
    //     const transform = direction=== 'vertical' ? ('0,' + offset + 'px,0') : (offset + 'px, 0,0')
    //     element.style.transform = 'translate3d('+transform+')'
    //   }
    //   if (scrollTop < elementStart) {
    //     element.style.transform = 'translate3d(0, 0, 0)'
    //   }
    // }
  };

  scrollEvent = (e) => {
    const scrollTop = window.scrollY !== undefined ? window.scrollY : window.pageYOffset

    const allScrollElements = document.querySelectorAll('[data-scroll-effect]')

    window.LAST_SCROLL = Date.now()

    for (let i = 0; i < allScrollElements.length; ++i) {
      const element = allScrollElements[i]
      const effects = element.attributes['data-scroll-effect'].value.split(',')

      const elementStart = element.offsetTop
      const elementIndex = this.hasEffect.indexOf(element)

      if (scrollTop >= elementStart) {
        if (elementIndex === -1) {
          effects.forEach((effect) => {
            const [className, duration] = effect.trim().split(' ')
            element.style.animationDuration = duration

            const trigger = element.hasAttribute('data-scroll-offset')
              ? JSON.parse(element.attributes['data-scroll-offset'].value)
              : {}

            const mediaTrigger = Object.keys(trigger).sort((a, b) => a > b ? 1 : -1).reduce(
              (mediaTrigger, breakpoint) => {
                if (this.state.width >= breakpoint) {
                  return trigger[breakpoint]
                }
                return mediaTrigger
              },
              0.0
            )

            const elementOffset = window.innerHeight * mediaTrigger

            if (scrollTop >= elementStart + elementOffset) {
              element.classList.add(className)
              this.hasEffect.push(element)
            }
          })
        }
      }
      if (scrollTop < elementStart) {
        if (elementIndex > -1) {
          effects.forEach(effect => element.classList.remove(effect.trim().split(' ')[0]))
          this.hasEffect[elementIndex] = undefined
        }
      }
    }

    const allLineElements = document.querySelectorAll('[data-parallax-line]')

    for (let i = 0; i < allLineElements.length; ++i) {
      const element = allLineElements[i]
      const width = element.attributes['data-parallax-line'].value

      const elementStart = element.offsetTop - window.innerHeight

      if (scrollTop >= elementStart + (window.innerHeight + window.innerHeight / 5)) {
        element.style.setProperty('width', width)
      }
    }
  };

  getChildContext() {
    return {
      width: this.state.width,
      height: this.state.height,
      retina: this.state.retina
    }
  }

  componentDidMount() {
    window.SCROLL_TIME = 468
    require('../utils/smoothScrolling').polyfill()

    this.nav = document.getElementById('navigation')
    this.mount = document.getElementById('react-mount')
    this.scrollElement = document.documentElement.scrollHeight > document.body.scrollHeight
      ? document.documentElement
      : document.body

    this.lastScrollTop = window.scrollY !== undefined ? window.scrollY : window.pageYOffset

    const allScopeElements = document.querySelectorAll('[data-scroll-effect]')

    for (let i = 0; i < allScopeElements.length; ++i) {
      allScopeElements[i].className += ' animated invisible'
    }

    setTimeout(() => document.getElementById('ninja-logo').style.opacity = 1.0, 500)
    setTimeout(() => intro.style.opacity = 0.0, 1400)
    setTimeout(() => window.scroll({ top: 0 }), 1399)
    document.getElementById('navigation').classList.add('animated')
    window.IS_SCROLLING = Date.now()

    this.updateDevice()
    this.draw()

    window.addEventListener('scroll', e => throttle(() => this.scrollEvent(e), 20)())

    window.addEventListener('resize', () => {
      this.updateDevice()
    })
  }

  render() {
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ../containers/DeviceProvider.js